import React, { useEffect, useState } from "react";
import { Tabs } from "antd";
import { FormikProvider, useFormik } from "formik";
import { BillSegment } from "./BillSegment";
import {
  DEFAULT_BILLING_TRANSACTION,
  DEFAULT_BILLING_SUBSCRIPTION,
  DEFAULT_BILLING_SJCRH,
  BILLING_TABS_OBJECT,
  UBER_TEXT,
} from "../../../constants/constants";
import {
  billingSubscriptionSchema,
  billingTransactionSchema,
  billing_sjcrhSchema,
} from "../../../utils/validations";
import { CheckCircleOutlined } from "@ant-design/icons";
import UberCarIcon from "../../../assets/svgs/ubercar.svg";
import { DatePickerToolTip } from "../../../pages/MH_Admin/MHEditRide/TooltipMessages";
import styles from "./index.module.css";
import { Input } from "../../formControls/Input/Input";
import { useSelector } from "react-redux";

export const BillingAndInvoicing = ({
  user,
  tab,
  isViewDashboardMode,
  onChange,
  HOPricing,
  onSubmitPricing,
}) => {
  const [selectedTab, setSelectedTab] = useState(tab);
  const HOPreferences = useSelector((state) => state.healthOrganizations.HOPreferences);
  
  const uberSurcharge = HOPreferences?.addons?.uberHealthSurcharge ?? 0;
  const surchargeFormik = useFormik({
    enableReinitialize: true,
    initialValues: { uberHealthSurcharge: uberSurcharge ?? 0 },
    onSubmit: () => {},
  });
  useEffect(()=>{

    setSelectedTab(tab);

    
  },[tab]);

  const shouldHideTabs = tab  === BILLING_TABS_OBJECT.SJCRH;
  let items;
  shouldHideTabs
    ? (items = [
        {
          key: BILLING_TABS_OBJECT.SJCRH,
          label: "Transaction",
          children: (
            <>
              <BillSegment
                tab={tab}
                Default_Value={HOPricing?.pricingType === BILLING_TABS_OBJECT.SJCRH ? HOPricing : DEFAULT_BILLING_SJCRH}
                billingSchema={billing_sjcrhSchema}
                onSubmitPricing={onSubmitPricing}
              />
            </>
          ),
        },
      ])
    : (items = [
        {
          key: BILLING_TABS_OBJECT.Transaction ,
          label: (
            <span onClick={() => setSelectedTab(BILLING_TABS_OBJECT.Transaction)}>
              {selectedTab === BILLING_TABS_OBJECT.Transaction ? <CheckCircleOutlined /> : null}
              Transaction
            </span>
          ),
          children: (
            <>
              <BillSegment
                tab={tab}
                Default_Value={
                  HOPricing?.pricingType === BILLING_TABS_OBJECT.Transaction
                    ? HOPricing
                    : DEFAULT_BILLING_TRANSACTION
                }
                onSubmitPricing={onSubmitPricing}
                billingSchema={billingTransactionSchema}
              />
            </>
          ),
        },
        {
          key: BILLING_TABS_OBJECT.Subscription ,
          label: (
            <span onClick={() => setSelectedTab(BILLING_TABS_OBJECT.Subscription)}>
              {selectedTab === BILLING_TABS_OBJECT.Subscription ? <CheckCircleOutlined /> : null}
              Subscription
            </span>
          ),
          children: (
            <>
              <BillSegment
                tab={tab}
                billingSchema={billingSubscriptionSchema}
                Default_Value={
                  HOPricing?.pricingType === BILLING_TABS_OBJECT.Subscription
                    ? HOPricing
                    : DEFAULT_BILLING_SUBSCRIPTION
                }
                onSubmitPricing={onSubmitPricing}
              />
            </>
          ),
        },
        {
          key: BILLING_TABS_OBJECT.UberHealth,
          label: (
            <span onClick={() => setSelectedTab(BILLING_TABS_OBJECT.UberHealth)}>
              {selectedTab === BILLING_TABS_OBJECT.UberHealth ? <CheckCircleOutlined /> : null}
              <img src={UberCarIcon} alt="Uber Health" style={{ width: 18, height: 18, marginRight: 6 }} />
              Uber Health
            </span>
          ),
          children: (
            <FormikProvider value={surchargeFormik}>
              <div className={styles.renderField}>
                <label className={styles.labelRidecost}>
                  Uber Health Surcharge
                </label>
                <div className={styles.uberHealthRow}>
                  <div className={styles.uberHealthInputWrapper}>
                    <Input
                      name="uberHealthSurcharge"
                      type="number"
                      min={0}
                      precision={2}
                      step={0.01}
                      disabled
                      prefix={<span className={styles.currencySymbol}>$</span>}
                      value={uberSurcharge ?? 0}
                      myClassName={styles.uberHealthInput}
                    />
                  </div>
                  <DatePickerToolTip
                    message={UBER_TEXT.BILLING_UBER_SURCHARGE_TOOLTIP}
                    useSvgIcon
                  />
                </div>
              </div>
            </FormikProvider>
          ),
        },
      ]);
  return (
    <>
      {isViewDashboardMode ? (
        <div style={{ marginBottom: "20px" }}>
          <h2> Billing & Invoicing </h2>
          <Tabs
            activeKey={selectedTab}
            items={items}
            onChange={onChange}
          />
        </div>
      ) : null}
    </>
  );
};
